import React, { createContext, useState, useEffect } from "react";
import { Alert } from 'flowbite-react';
import { HiInformationCircle } from 'react-icons/hi';
export const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alertMessage, setAlertMessage] = useState(null);
  const [alertColor, setAlertColor] = useState(null);
  const [timerId, setTimerId] = useState(null);

  useEffect(() => {
    if (alertMessage && !timerId) {
      const id = setTimeout(() => {
        setAlertMessage(null);
        setTimerId(null);
      }, 5000);

      setTimerId(id);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [alertMessage, timerId]);

  return (
    <AlertContext.Provider value={{ alertMessage, setAlertMessage, setAlertColor }}>
      {children}
      {alertMessage && (
        <div className="toast-container">
          <Alert color={alertColor} icon={HiInformationCircle}>
            <span>
              <p>
                <span className="font-medium">Info alert! </span>
                {alertMessage}
              </p>
            </span>
          </Alert>
        </div>
      )}
    </AlertContext.Provider>
  );
};
